import {useLocalization} from "./i18n";
import React, {useMemo} from "react";
import {DataTableColumn} from "@variocube/app-ui";
import {Inbox} from "./api";
import {Chip, Link, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

export function useInboxColumns() {
	const {t} = useLocalization();

	return useMemo<DataTableColumn<Inbox>[]>(() => [
		{
			field: "name",
			label: t("inboxes.singular"),
			component: ({row}) => (
				<Typography variant="body1">
					<Link component={RouterLink} to={`${row.id}`} relative="path" color="secondary">
						{row.name}
					</Link>
				</Typography>
			),
		},
		{
			field: "businessCenterAddress",
			label: "BCA",
			component: ({row}) => <Chip label={row.businessCenterAddress}/>,
		},
		{
			field: "companyCode",
			label: t("inboxes.companyCode"),
			component: ({row}) => <Chip label={row.companyCode}/>,
		},
	], [t])
}
